// extracted by mini-css-extract-plugin
export default {"label":"typography_label__w6UVh","title":"typography_title__jfWnw"};